<script>
    import SortableTable from '../SortableTable.svelte';
    import {tables} from '../../lib/tables';
    import {forms} from '../../lib/forms';
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import { notifier } from '@beyonk/svelte-notifications';

    import keyRecommendationModel from '../../Models/keyRecommendationModel';

    export let assessment_model;

    const MAX_RECOMMENDATIONS = 15;

    let assessment = assessment_model.store;

    let modal;

    let collapsed = true;

    let suggested_services = [];

    let key_recommendations = keyRecommendationModel.getKeyRecommendationList();

    async function get_recommendations(assessment) {
        let promises = [];
        for (let category of assessment.assessment_type_data.categories) {
            for (let subcategory of category.subcategories) {
                for (let question of subcategory.controls) {
                    if (question.tag_mapping) {
                        for (let [tag_id, mapping] of Object.entries(question.tag_mapping)) {
                            if (assessment_model.getTag(question.id, tag_id).value == 1){
                                for (let map of mapping) {
                                    if (map.startsWith("keyRecommendation")) {
                                        promises.push(keyRecommendationModel.getKeyRecommendation(map))
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        let settled_promises = await Promise.allSettled(promises);
        let results = [];
        for (let p of settled_promises) {
            if (p.status == "fulfilled") {
                results.push(p.value);
            }
        }

        suggested_services = results;
    }

    function addKeyRecommendation() {
        addFormModal({
            fields: forms['keyRecommendation']
        }).then((formData) => {
            assessment_model.addKeyRecommendation(formData)
        })
    }

    function updateKeyRecommendation(recommendation) {
        addFormModal({
            fields: forms['keyRecommendation'],
            data: recommendation
        }).then( formData => {
            assessment_model.updateKeyRecommendation(formData)
        })
    }

    function deleteKeyRecommendation(recommendation) {
        assessment_model.deleteKeyRecommendation(recommendation);
    }

    function doAddFromTemplate(key_recommendation) {
        key_recommendation.template_id = key_recommendation._id,

        key_recommendation._id = undefined;
        key_recommendation._rev = undefined;
        key_recommendation.item_id = undefined;
        assessment_model.addKeyRecommendation(key_recommendation);
    }

    function addRecommendationFromTemplate() {
        return new Promise((resolve, reject) => {
            modal = {
                cancelAction: reject,
                saveAction: resolve
            }
        }).then((recommendation_id) => {
            keyRecommendationModel.getKeyRecommendation(recommendation_id).then(doAddFromTemplate)
        }).catch(() => {
            null
        }).finally(() => {
            modal = undefined;
        })
    }

    function updateRecommendationTemplate(recommendation) {
        keyRecommendationModel.updateKeyRecommendation(recommendation).then(() => {
            notifier.success("Recommendation Template Updated")
        }).catch(() => {
            notifier.danger("Error Updating Template. Template may no longer exist.")
        });
    }

    function saveRecommendationAsTemplate(recommendation) {
        let recommendationTemplate = {
            text: recommendation.text
        }

        keyRecommendationModel.createKeyRecommendation(recommendationTemplate).then((res) => {
            recommendation.template_id = res.id;

            assessment_model.updateKeyRecommendation(recommendation);

            notifier.success("Recommendation Template Created");
        })
    }

    $: get_recommendations($assessment);
</script>
<h2 class="title is-2">Key Recommendations</h2>
<SortableTable sortFields={tables['keyRecommendations']} tableData={$assessment.key_recommendations} tableClass="NISTTable">
    <div slot="filterActions">
        {#if $assessment.key_recommendations.length < MAX_RECOMMENDATIONS}
            <button class="button is-success" on:click={addKeyRecommendation}>Add Key Recommendation</button>
        {/if}
    </div>
    <div slot="rowActions" let:row={recommendation}>
        <div class="buttons">
            <button class="button is-primary" on:click={() => updateKeyRecommendation(recommendation)}>Edit</button>
            <button class="button is-danger" on:click={() => deleteKeyRecommendation(recommendation)}>Delete</button>
            {#if recommendation.template_id}
                <button class="button is-link" on:click={() => updateRecommendationTemplate(recommendation)}>Update Template</button>
            {/if}
            <button class="button is-info" on:click={() => saveRecommendationAsTemplate(recommendation)}>Save as New Template</button>
        </div>
    </div>
    <div slot="footerActions">
        <div class="buttons is-right">
            {#if $assessment.key_recommendations.length < MAX_RECOMMENDATIONS}
                <button class="button is-primary" on:click={addRecommendationFromTemplate}>Add From Template</button>
            {/if}
        </div>
    </div>
</SortableTable>

{#if $assessment.key_recommendations.length < MAX_RECOMMENDATIONS && suggested_services.length}
<h3 class="title is-4 pointer" on:click={() => collapsed = !collapsed}>{collapsed ? "[+]" : "[-]"} Mapped Services</h3>
    {#if !collapsed}
        <SortableTable sortFields={tables['keyRecommendations']} tableData={suggested_services} tableClass="NISTTable">
            <div slot="rowActions" let:row={service}>
                <button class="button is-link" on:click={() => doAddFromTemplate(service)}>Add To Report</button>
            </div>
        </SortableTable>
    {/if}
{/if}

{#if modal}
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card is-fullwidth">
            <header class="modal-card-head">
            <p class="modal-card-title">Create from Template</p>
                <button class="delete" aria-label="close" on:click={modal.cancelAction}></button>
            </header>
            <section class="modal-card-body">
                <SortableTable sortFields={tables["keyRecommendations"]} tableData={$key_recommendations} tableClass="NISTTable">
                    <div slot="rowActions" let:row={recommendation}>
                        <div class="button is-success" on:click={() => modal.saveAction(recommendation._id)}>Select Control</div>
                    </div>
                </SortableTable>
            </section>
            <footer class="modal-card-foot has-text-right">
                <button class="button is-pulled-right" on:click={modal.cancelAction}>Close</button>
            </footer>
        </div>
    </div>
{/if}